import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import ModalCloseContainer from './ModalCloseContainer';

const ModalContainer = styled.div`
  height: 100%;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`;

const TransparentBackdrop = styled(ModalContainer)`
  background: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
  background: white;
  margin: 4rem auto 1rem;
  position: relative;
  width: 30rem;
  min-height: 23rem;
  max-height: 56rem;
  overflow-y: auto;
  display: flex;
  z-index: 10;

  /* intended to make sure small windows or netbooks don't get a lot of padding added to them */
  @media screen and (max-height: 769px) {
    margin: 0.5rem auto;
  }

  &.pp-flyer-comparison-modal {
    max-width: 52rem;
    width: calc(100% - 3rem);
  }

  &.pp-flyer-pricing-modal {
    max-width: 52rem;
    width: calc(100% - 3rem);
  }

  &.pp-card-preview-modal {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 90%;
    max-width: 70rem;
    max-height: 50rem;
  }

  &.pp-coin-info-modal {
    width: 39rem;
    max-height: 32rem;
  }
`;

// This modal container is intended for use on desktop
export default class BackdropModal extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
  };

  componentDidMount() {
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.height = '';
    document.body.style.overflow = '';
  }

  render() {
    const { className, useAltCloseButton, closeAction } = this.props;

    const closeButton = !useAltCloseButton ? (
      <ModalCloseContainer isMobile={false} closeCallback={closeAction} />
    ) : null;

    let children = this.props.children;

    if (useAltCloseButton) {
      children = Children.map(this.props.children, child =>
        React.cloneElement(child, { closeAction }),
      );
    }

    const backdrop = (
      <ModalContainer onClick={e => e.stopPropagation()}>
        <TransparentBackdrop onClick={e => closeAction()} />
        <ModalContent className={`pp-modal-takeover ${className}`}>
          {closeButton}
          {children}
        </ModalContent>
      </ModalContainer>
    );

    return backdrop;
  }
}
